import BroadcastChannelPolyfill from './models/BroadcastChannelPolyfill';
var CrossApplicationCommunication = /** @class */ (function () {
    function CrossApplicationCommunication() {
        this.broadcastChannels = new Map();
    }
    CrossApplicationCommunication.prototype.getBroadcastChannel = function (channelKey) {
        var broadcastChannel = this.broadcastChannels.get(channelKey);
        if (!broadcastChannel) {
            broadcastChannel = new (window.BroadcastChannel || BroadcastChannelPolyfill)(channelKey);
            this.broadcastChannels.set(channelKey, broadcastChannel);
        }
        return broadcastChannel;
    };
    CrossApplicationCommunication.prototype.publish = function (topic, payload) {
        var broadcastChannel = this.getBroadcastChannel(topic);
        broadcastChannel.postMessage(payload);
    };
    CrossApplicationCommunication.prototype.subscribe = function (topic, callback) {
        var broadcastChannel = this.getBroadcastChannel(topic);
        broadcastChannel.addEventListener('message', function (event) {
            callback(event.data);
        });
    };
    return CrossApplicationCommunication;
}());
export default new CrossApplicationCommunication();
//# sourceMappingURL=CrossApplicationCommunication.js.map